<div class="fluid-container text-start text-md-center my-5 py-5 how-it-works">
    <div class="container py-0 py-md-4">
        <h3 class="mb-0 mb-md-5">
            <span [innerHTML]="'how-it-works-title' | cmsText | async"></span>
        </h3>
        <div class="d-flex justify-content-between my-4 row">
            <div
                class="col-md-2 col-12 my-3 my-md-0"
                *ngFor="let key of [1, 2, 3, 4]"
            >
                <div class="row">
                    <div class="col-md-9 col-3 mx-auto">
                        <img
                            class="img-fluid p-1 p-md-2 p-lg-3 rounded-img"
                            [attr.src]="
                                'how-it-works-bullet-' + key + '-img'
                                    | cmsImageSrc
                                    | async
                            "
                            [attr.alt]="
                                'how-it-works-bullet-' + key + '-img'
                                    | cmsImageAlt
                                    | async
                            "
                        />
                    </div>
                    <div class="col-md-12 col-9 my-auto">
                        <p class="mt-0 mt-md-3">
                            <span
                                [innerHTML]="
                                    'how-it-works-bullet-' + key + '-text'
                                        | cmsText
                                        | async
                                "
                            ></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <a
                [routerLink]="'../info'"
                id="moreInfo"
                class="btn btn-primary px-3"
            >
                <app-content key="more-info-button-text"></app-content>
                <i class="ms-3 fa fa-chevron-right"></i>
            </a>
        </div>
    </div>
</div>
